import React from 'react';
import CardActions from '../card-actions';
import frontVector from '../../../assets/img/front-vector.svg';
import { APP_TITLE } from '../../../constants';
import Essence from '../../../models/cardEssences';
import { PhotographIcon } from '@heroicons/react/solid';

const Content = ({
  card,
  showCardActions,
  readonly,
  onClick = () => {},
  pictureSize = { width: 85, height: 95 },
  hielocoSize = { width: 20, height: 20 },
}) => {
  return (
    <>
      {/* Left */}
      <div className="absolute top-5 left-5 z-10 " onClick={(e) => onClick(e)}>
        <div className="flex gap-5 w-full card">
          {/* Card Image */}
          <div
            className="bg-gray-100 rounded-md flex gap-2 relative"
            style={{ ...pictureSize }}
          >
            {card.picture && (
              <img
                alt="userPicture"
                src={
                  typeof card.picture === 'object'
                    ? URL.createObjectURL(card.picture)
                    : card.picture
                }
                className="object-cover w-full h-full z-10 rounded"
              />
            )}
            <div className="absolute top-1 left-1">
              <PhotographIcon width={24} className="text-gray-300" />
            </div>
          </div>
          {/* Card Name */}
          <div className="w-32" style={{ color: '#00A0BA', width: '9rem' }}>
            <span className="md:text-lg">
              {card.name_on_card || 'Nombre en tarjeta'}
            </span>

            <div className="mt-2">
              {/* Hielocos */}
              {card?.Card_Hielocos && card?.Card_Hielocos.length > 0 && (
                <div className="flex items-center gap-1">
                  {card.Card_Hielocos.slice(0, 5).map((cardHieloco, index) => (
                    <img
                      alt="poapImage"
                      key={index}
                      src={cardHieloco.Hieloco.image_url}
                      className="rounded-full object-cover"
                      style={{ ...hielocoSize }}
                    />
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <div
        className="relative h-full overflow-hidden"
        onClick={(e) => onClick(e)}
      >
        <img
          alt="background"
          src={frontVector}
          className="h-full absolute -right-2 top-5 scale-125 md:scale-x-100 transform"
        />
      </div>

      <div className="absolute bottom-3 left-5 space-y-3 mt-3">
        <div className="flex items-center">
          {card.Card_Essences_Values.map((essence, index) => (
            <div style={new Essence(essence).style} key={index} />
          ))}
        </div>

        <div style={{ color: '#00789C' }} className="card">
          1821
        </div>
      </div>
      {card.code && (
        <div className="absolute bottom-5 right-4 space-y-2 card">
          <div
            className="w-12 text-center text-white font-medium py-1"
            style={{ backgroundColor: '#F29066' }}
          >
            {card.code.slice(0, 3)}
          </div>
          <div
            className="w-12 text-center text-white font-medium py-1"
            style={{ backgroundColor: '#9E376B' }}
          >
            {card.code.slice(3, 7)}
          </div>
        </div>
      )}

      {!readonly && (
        <div className="absolute -top-4 -right-2">
          <CardActions card={card} isVisible={showCardActions} />
        </div>
      )}
    </>
  );
};

export default Content;
